export const classNames = (...classes: any) => {
  return classes.filter(Boolean).join(' ');
};

export function toGMT7HourMinute(isoString: string) {
  return new Date(isoString).toLocaleString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'Asia/Ho_Chi_Minh'
  });
}
// Example: toGMT7Full("2026-08-28T02:00:00.000Z");  "28/08, 09:00"